(function () {
  const countSelectors = '#ProductCount, #ProductCountDesktop, .collection-filter-bar .product-count [data-product-count]';

  const parsePage = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const root = doc.querySelector('[data-infinite-scroll]');
    const grid = doc.getElementById('product-grid');
    return {
      items: grid ? Array.from(grid.querySelectorAll('.grid__item')) : [],
      nextUrl: root?.getAttribute('data-next-url') || '',
    };
  };

  const updateProductCount = () => {
    const grid = document.getElementById('product-grid');
    const root = document.querySelector('[data-infinite-scroll]');
    if (!grid) return;

    const shown = grid.querySelectorAll('.grid__item').length;
    const total =
      root?.getAttribute('data-products-total') ||
      document.querySelector('#ProductCount')?.getAttribute('data-total-count') ||
      '';

    document.querySelectorAll(countSelectors).forEach((el) => {
      el.setAttribute('data-product-count', String(shown));
      const elTotal = el.getAttribute('data-total-count') || total;
      if (!elTotal) return;
      el.textContent = `${shown}/${elTotal}`;
    });
  };

  const bindCountObserver = (grid) => {
    if (grid.dataset.countObserverBound === 'true') return;
    grid.dataset.countObserverBound = 'true';
    new MutationObserver(updateProductCount).observe(grid, { childList: true });
    updateProductCount();
  };

  const bindLoader = () => {
    const root = document.querySelector('[data-infinite-scroll]');
    const grid = document.getElementById('product-grid');
    if (!root || !grid) return;

    bindCountObserver(grid);

    const sentinel = root.querySelector('[data-infinite-scroll-sentinel]');
    const spinner = root.querySelector('[data-infinite-scroll-spinner]');
    const sectionId = root.getAttribute('data-section-id') || grid.dataset.id;
    if (!sentinel || !sectionId || root.dataset.infiniteScrollBound === 'true') return;
    if (!root.getAttribute('data-next-url')) return;

    root.dataset.infiniteScrollBound = 'true';
    document.documentElement.classList.add('infinite-scroll-enabled');

    let loading = false;
    let nextUrl = root.getAttribute('data-next-url') || '';

    const nearBottom = () => {
      if (!sentinel.isConnected) return false;
      return sentinel.getBoundingClientRect().top <= window.innerHeight + 240;
    };

    const loadMore = async () => {
      if (loading || !nextUrl || !grid.isConnected) return;
      loading = true;
      spinner?.classList.remove('hidden');

      try {
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Failed to load more products');

        const { items, nextUrl: upcoming } = parsePage(await response.text());
        items.forEach((item) => grid.appendChild(item));
        updateProductCount();

        nextUrl = upcoming;
        if (nextUrl) {
          root.setAttribute('data-next-url', nextUrl);
        } else {
          root.removeAttribute('data-next-url');
          sentinel.remove();
        }
      } catch (error) {
        console.error(error);
      } finally {
        loading = false;
        spinner?.classList.add('hidden');
      }
    };

    const onScroll = () => {
      if (nearBottom()) loadMore();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadMore();
        },
        { rootMargin: '240px 0px' },
      ).observe(sentinel);
    }
  };

  const start = () => bindLoader();

  if (window.__collectionInfiniteScroll) return;
  window.__collectionInfiniteScroll = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
  document.addEventListener('product-grid:updated', start);
})();
